const Sdata=[
{    id:"1",
    imgsrc:"https://wallpapercave.com/wp/wp4056410.jpg",
    title:"A Netflix Original Series",
    sname:"DARK",
    links:"https://www.netflix.com/in/title/80990668?source=35"
}

,
{   id:"2",
    imgsrc:"https://wallpapercave.com/wp/wp1917154.jpg",
    title:"A Netflix Original Series",
    sname:"STRANGER THINGS",
    links:"https://www.netflix.com/in/title/80990668?source=35"
}
,
{   id:"3",
    imgsrc:"https://images.justwatch.com/poster/8589251/s592",
    title:"Azon Original Series",
    sname:"The Vampire Diaries",
    links:"https://www.netflix.com/in/title/80990668?source=35"
}

,
{   id:"4",
    imgsrc:"https://wallpapercave.com/wp/wp4056410.jpg",
    title:"A Netflix Original Series",
    sname:"DARK",
    links:"https://www.netflix.com/in/title/80990668?source=35"
}

,
{   id:"5",
    imgsrc:"https://wallpapercave.com/wp/wp1917154.jpg",
    title:"A Netflix Original Series",
    sname:"STRANGER THINGS",
    links:"https://www.netflix.com/in/title/80990668?source=35"
}
,
{   id:"6",
    imgsrc:"https://images.justwatch.com/poster/8589251/s592",
    title:"Azon Original Series",
    sname:"The Vampire Diaries",
    links:"https://www.netflix.com/in/title/80990668?source=35"
}



]

export default Sdata ;